import { motion } from "framer-motion";
import { formatCurrency } from "../../../data/mock/dashboardData";

const TONES = ["bg-emerald-500", "bg-accent", "bg-orange-400", "bg-red-400"];

/**
 * @param {{ buckets?: Array<{ label: string, amount?: number, pct?: number, count?: number }> }} props
 */
export default function AgingBucketsChart({ buckets: bucketsProp } = {}) {
  if (!Array.isArray(bucketsProp) || bucketsProp.length === 0) {
    return (
      <p className="flex min-h-[160px] items-center justify-center text-sm text-primary/40">
        No overdue balance data yet.
      </p>
    );
  }

  const buckets = bucketsProp.map((b, i) => ({
    label: b.label,
    amount: Number(b.amount) || 0,
    pct: Number(b.pct) || 0,
    count: Number(b.count) || 0,
    tone: TONES[i % TONES.length],
  }));

  return (
    <div className="space-y-3">
      {buckets.map((bucket, i) => (
        <div key={bucket.label}>
          <div className="mb-1.5 flex items-baseline justify-between gap-2">
            <span className="text-xs font-medium text-primary/70">{bucket.label}</span>
            <span className="text-xs font-bold text-primary">{formatCurrency(bucket.amount)}</span>
          </div>
          <div className="relative h-2 overflow-hidden rounded-full bg-primary/[0.06]">
            <motion.div
              className={`absolute inset-y-0 left-0 rounded-full ${bucket.tone}`}
              initial={{ width: 0 }}
              animate={{ width: `${Math.min(100, bucket.pct)}%` }}
              transition={{ duration: 0.7, delay: 0.15 + i * 0.1, ease: "easeOut" }}
            />
          </div>
          <p className="mt-1 text-[10px] text-primary/35">
            {bucket.count} accounts · {bucket.pct}% of overdue outstanding
          </p>
        </div>
      ))}
    </div>
  );
}
